var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-5da6be34-c231-408c-8c5c-6ce96ee9710e",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1027.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .uuid-fc02d077-250a-4ea6-8bf1-b0225203882b {\r\n        fill: url(#uuid-e5df93ad-b2ac-46b5-82a9-01e412572cd3);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e5df93ad-b2ac-46b5-82a9-01e412572cd3",
    x1: 64.7,
    y1: -147.94,
    x2: 860.83,
    y2: 724.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#150335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#270233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5c012d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#840029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9c0026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a50026"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-fc02d077-250a-4ea6-8bf1-b0225203882b",
    d: "M1058.9,11.21c-23.59-18.11-57.74-13.87-76.03,9.8l-104.05,134.8C785.68,60.82,656.13,1.65,512.9,1.65,230.08,1.65,0,231.73,0,514.54s230.08,512.89,512.9,512.89,512.9-230.08,512.9-512.89c0-99.39-28.88-191.96-78.01-270.61l120.91-156.64c18.29-23.72,13.92-57.76-9.8-76.08ZM922.05,514.54c0,225.61-183.54,409.14-409.15,409.14S103.75,740.15,103.75,514.54,287.29,105.4,512.9,105.4c119.45,0,226.77,51.77,301.64,133.68l-299.26,387.69-167.36-241.75c-17.08-24.57-50.78-30.81-75.45-13.71-24.62,17.05-30.76,50.83-13.71,75.45l209.56,302.7c9.85,14.19,25.89,22.87,43.18,23.35h1.4c16.78,0,32.64-7.78,42.91-21.07l323.22-418.71c27.28,54.79,43.03,116.28,43.03,181.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.98279d1515aea6f3e2325edc36385c0a.svg";
export { ForwardRef as ReactComponent };